import { useEffect } from 'react'

const META_PIXEL_ID = '904978025482552'

export function useMetaPixel() {
  useEffect(() => {
    // Defer pixel loading to after page is interactive
    const loadPixel = () => {
      // Prevent double initialization
      if ((window as any).fbq) return

      const f = window as any
      const n = (f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args)
        } else {
          n.queue.push(args)
        }
      })

      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = [] as any[]

      // Load the Facebook Pixel script
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript?.parentNode?.insertBefore(script, firstScript)

      // Initialize and track PageView
      f.fbq('init', META_PIXEL_ID)
      f.fbq('track', 'PageView')

      // Add noscript fallback
      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }

    // Use requestIdleCallback to load after main content, fallback to setTimeout
    if ('requestIdleCallback' in window) {
      ;(window as any).requestIdleCallback(loadPixel, { timeout: 3000 })
    } else {
      setTimeout(loadPixel, 2000)
    }
  }, [])
}
